import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
    changeCurrentPath,
    getJigyoshaList,
    resetMainListState,
    resetConsigneeListStateNew,
} from '../../../actions';

import Header from '../../../common/containers/header';
import Progress from '../../../common/containers/progress'
import SpNav from '../../../common/containers/sp_nav'
import Footer from '../../../common/containers/footer';

import ErrorDialog from '../../../common/components/dialog/error-dialog';
import ReloadModal from '../../../common/components/dialog/reload-dialog';
import LogoutModal from '../../../common/components/dialog/logout-dialog';

import MainButtons from '../../../common/components/main-buttons';
import SuggestSelect from '../../../common/components/input/suggest-select';

import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';


const styles = theme => ({
    singInButton: {
        marginRight: theme.spacing.unit,
    },
    textField:{
        width:'100%',
        marginBottom:15
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
});

class MasterAddUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            JigyoushaCD:null,
            inputData:{
                JigyoushaCD: '',
                UserID: '',
                UserName: '',
                Furigana: '',
                UserPassword: '',
                UserPasswordConf:'',
                Kengen: ''
            },
            showPassword : false,
            showPasswordConf : false
        }
    }
	/** override methods **/
    UNSAFE_componentWillMount() {
	    const {dispatch} = this.props;

        dispatch(resetMainListState());
        dispatch(resetConsigneeListStateNew());
        dispatch(getJigyoshaList());
	}
    
    
    /** override methods **/
	componentDidMount() {
		const { dispatch, history } = this.props;
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
    
    /** event handlers **/
    _handleChange(event) {
        let inputData = this.state.inputData;
        switch (event.target.name) {
            case 'JigyoushaCD':
                inputData.JigyoushaCD = event.target.value;
                break;
            case 'UserID':
                inputData.UserID = event.target.value;
                break;
            case 'UserName':
                inputData.UserName = event.target.value;
                break;
            case 'Furigana':
                inputData.Furigana = event.target.value;
                break;
            case 'UserPassword':
                inputData.UserPassword = event.target.value;
                break;
            case 'UserPasswordConf':
                inputData.UserPasswordConf = event.target.value;
                break;
            case 'Kengen':
                inputData.Kengen = event.target.value;
                break;
            default:
                break;
        }
        this.setState({
            inputData
        });
    }

    _handleJigyoshaChange = data =>{
        let inputData = this.state.inputData;
        inputData.JigyoushaCD = (data === null) ? '' : data.value;
        this.setState({
            inputData,
        });
        if(data !== null){
            this.UserID.focus();
        }
    };

    _handleKeyPress(event){
        if(event.key !== 'Enter'){
            return
        }
        /*
        const inputData = this.state.inputData;

        let JigyoushaCD = inputData.JigyoushaCD;
        let UserID = inputData.UserID;
        let UserName = inputData.UserName;
        let Furigana = inputData.Furigana;
        let UserPassword = inputData.UserPassword;
        let UserPasswordConf = inputData.UserPasswordConf;
        let Kengen = inputData.Kengen;
          */

        switch (event.target.name) {
            case 'JigyoushaCD':
                this.UserID.focus();
                break;
            case 'UserID':
                this.UserName.focus();
                break;
            case 'UserName':
                this.Furigana.focus();
                break;
            case 'Furigana':
                this.UserPassword.focus();
                break;
            case 'UserPassword':
                this.UserPasswordConf.focus();
                break;
            case 'UserPasswordConf':
                this.Kengen.focus();
                break;
            case 'Kengen':
                this.JigyoushaCD.focus();
                break;
            default:
                break;
        }
    }

    _handleClickShowPassword(){
        this.setState({ showPassword: !this.state.showPassword });
    }

    _handleClickShowPasswordConf(){
        this.setState({ showPasswordConf: !this.state.showPasswordConf });
    }

    handleClickSave = () =>{

    };

    handleClickClear = () =>{

    };
	


    render() {
        const { settings, classes} = this.props;

        const suggestions = settings.jigyoshaData.map(suggestion => ({
            value: suggestion.JigyoushaCD,
            label: suggestion.JigyoushaCD + ' : ' + suggestion.JigyoushaName,
        }));

        const mainButtons = [
            {type:'SAVE',func:this.handleClickSave},
            {type:'CLEAR',func:this.handleClickClear},
        ];


        return (
            <div id="main_container">
                {settings.isFetching &&
                <Progress/>
                }
                <SpNav history={this.props.history}/>
                <Header history={this.props.history}/>
                <article>
                    <section className="title_area">
                        <h2>ユーザー登録</h2>
                    </section>
                    <section className="with_button">
                        <SuggestSelect
                            inputLabel="事業者コード"
                            suggestions={suggestions}
                            afterChangeFunction={this._handleJigyoshaChange}
                            maxLength={10}
                            fixValue={settings.JigyoushaCD}
                        />
                        <div className={classes.divider} />
                        <TextField
                            label="ユーザーID"
                            placeholder="ユーザーID"
                            className={classes.textField}
                            onKeyPress={this._handleKeyPress.bind(this)}
                            onChange={this._handleChange.bind(this)}
                            name="UserID"
                            inputRef={field => this.UserID = field}
                            inputProps={{
                                maxLength:20
                            }}
                        />
                        <TextField
                            label="ユーザー名"
                            placeholder="ユーザー名"
                            className={classes.textField}
                            onKeyPress={this._handleKeyPress.bind(this)}
                            onChange={this._handleChange.bind(this)}
                            name="UserName"
                            inputRef={field => this.UserName = field}
                            inputProps={{
                                maxLength:20
                            }}
                        />
                        <TextField
                            label="フリガナ"
                            placeholder="フリガナ"
                            className={classes.textField}
                            onKeyPress={this._handleKeyPress.bind(this)}
                            onChange={this._handleChange.bind(this)}
                            name="Furigana"
                            inputRef={field => this.Furigana = field}
                            inputProps={{
                                maxLength:20
                            }}
                        />

                        <TextField
                            label="パスワード"
                            placeholder="パスワード"
                            className={classes.textField}
                            type={this.state.showPassword ? 'text' : 'password'}
                            onKeyPress={this._handleKeyPress.bind(this)}
                            onChange={this._handleChange.bind(this)}
                            InputProps={{
                                endAdornment:(
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Toggle password visibility"
                                            onClick={this._handleClickShowPassword.bind(this)}
                                        >
                                            {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                            inputProps={{
                                maxLength:10
                            }}
                            name="UserPassword"
                            inputRef={field => this.UserPassword = field}
                        />
                        <TextField
                            label="パスワード確認"
                            placeholder="パスワード確認"
                            className={classes.textField}
                            type={this.state.showPasswordConf ? 'text' : 'password'}
                            onKeyPress={this._handleKeyPress.bind(this)}
                            onChange={this._handleChange.bind(this)}
                            InputProps={{
                                endAdornment:(
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Toggle password visibility"
                                            onClick={this._handleClickShowPasswordConf.bind(this)}
                                        >
                                            {this.state.showPasswordConf ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                            inputProps={{
                                maxLength:10
                            }}
                            name="UserPasswordConf"
                            inputRef={field => this.UserPasswordConf = field}
                        />




                    </section>
                </article>
                <MainButtons buttons={mainButtons}/>
                <Footer/>
                <ErrorDialog
                    open={settings.isProcessError}
                />
				<ReloadModal />
                <LogoutModal />
            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
	  navigation : state.navigation,
      auth: state.auth,
      settings : state.masterAddUserSettings,
	  
  };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(MasterAddUser);



// WEBPACK FOOTER //
// ./src/routes/master/add-user/index.js